import { Component, computed, input, output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MbpButtonComponent } from '@components/form';
import { downloadUrl, toImageSrc } from '@utils';

const ZOOM_STEP = 0.25;
const ZOOM_MIN = 1;
const ZOOM_MAX = 3;

@Component({
  selector: 'mbp-enlarge-image-modal',
  templateUrl: './enlarge-image-modal.component.html',
  styleUrl: './enlarge-image-modal.component.scss',
  imports: [TranslateModule, MbpButtonComponent]
})
export class EnlargeImageModalComponent {
  modalTitle = input.required<string>();
  picture = input.required<string>();
  fileName = input<string>('image.jpg');

  close = output<void>();

  protected imageSrc = computed(() => toImageSrc(this.picture()));
  protected zoomLevel = signal(1);

  protected onZoomIn(): void {
    this.zoomLevel.update((level) => Math.min(level + ZOOM_STEP, ZOOM_MAX));
  }

  protected onZoomOut(): void {
    this.zoomLevel.update((level) => Math.max(level - ZOOM_STEP, ZOOM_MIN));
  }

  protected onDownload(): void {
    downloadUrl(this.imageSrc(), this.fileName());
  }
}
